import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { Button, FullPageWrapper, SpinnerLoader, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { RcsPath } from 'pages/settings/pages/rcs/route/rcsPath'
import {
  useRcsCreateContext,
  RcsCreateProvider,
} from 'pages/settings/pages/rcs/context/rcsCreateContext'
import { RcsCreatePreview } from './RcsCreatePreview/RcsCreatePreview'
import { RcsCreateProfile } from './RcsCreateProfile/RcsCreateProfile'

import styles from './styles.module.scss'

export const RcsCreateContent = observer(() => {
  const store = useRcsCreateContext()
  const {
    loading,
    profileStore: { canCreate },
    create,
  } = store

  const onCancel = () => {
    uiStore.changeRoute({
      path: RcsPath.root,
    })
  }

  useEffect(() => {
    return () => {
      store.reset()
    }
  }, [])

  return (
    <div className={styles.wrap}>
      <div className={classnames(styles.box, styles.box__main)}>
        <div className={styles.header}>
          <Typography variant={'body-xs-regular'} className={styles.label} ariaLabel={'RCS'}>
            {'RCS'}
          </Typography>

          <div className={styles.titleWrap}>
            <Typography variant={'heading-md'} ariaLabel={'RCS'}>
              Public details
            </Typography>
          </div>
        </div>
        {store.loading ? (
          <div className={styles.loading}>
            <SpinnerLoader ariaLabel='rcsLoading' />
          </div>
        ) : (
          <div className={styles.wrapCreate}>
            <RcsCreateProfile />
          </div>
        )}
        <div className={styles.actions}>
          <Button
            loading={loading}
            disabled={loading}
            text='Cancel'
            size='medium'
            contained='secondary'
            onClick={onCancel}
          />
          <Button
            loading={loading}
            text='Submit'
            size='medium'
            disabled={!canCreate || loading}
            onClick={create}
          />
        </div>
      </div>

      <div className={classnames(styles.box, styles.box__preview)}>
        <RcsCreatePreview />
      </div>
    </div>
  )
})

export const RcsCreate = observer(() => (
  <FullPageWrapper className={styles.page}>
    <RcsCreateProvider>
      <RcsCreateContent />
    </RcsCreateProvider>
  </FullPageWrapper>
))
